module.exports = __webpack_public_path__ + "static/media/boy-placeholder.d7fd9e0b.png";